import { StarOn } from '@sgui-plus/icons-vue'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { mutable } from '@sgui-plus/utils/types'
import { isValidComponentSize } from '@sgui-plus/utils/validators'
import type { ComponentSize } from '@sgui-plus/utils/size'
import type { Component, ExtractPropTypes, PropType } from 'vue'
import type Rate from './rate.vue'

export const rateProps = buildProps({
  modelValue: {
    type: Number,
    default: 0,
  },
  lowThreshold: {
    type: Number,
    default: 2,
  },
  highThreshold: {
    type: Number,
    default: 4,
  },
  max: {
    type: Number,
    default: 5,
  },
  colors: {
    type: definePropType<string[] | Record<number, string>>([Array, Object]),
    default: () =>
      mutable([
        'var(--sg-rate-star-color)',
        'var(--sg-rate-star-color)',
        'var(--sg-rate-star-color)',
      ] as const),
  },
  icons: {
    type: definePropType<
      Array<string | Component> | Record<number, string | Component>
    >([Array, Object]),
    default: () => [StarOn, StarOn, StarOn],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  allowHalf: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String as PropType<ComponentSize>,
    validator: isValidComponentSize,
  },
} as const)

export type RateProps = ExtractPropTypes<typeof rateProps>

export const rateEmits = {
  onChange: (value: number) => typeof value === 'number',
  [UPDATE_MODEL_EVENT]: (value: number) => typeof value === 'number',
}
export type RateEmits = typeof rateEmits

export type RateInstance = InstanceType<typeof Rate>
